import DocRenderer from "@/components/admin/DocBlocks";
import { ENGAGEMENT_LETTER, ENGAGEMENT_META } from "@/content/engagementLetter";

export default function EngagementLetterDoc() {
  return <DocRenderer meta={ENGAGEMENT_META} sections={ENGAGEMENT_LETTER} testId="engagement-letter-doc" />;
}
